import { render } from "./composeVoice.vue?vue&type=template&id=5c54322b&scoped=true"
import script from "./composeVoice.vue?vue&type=script&lang=js"
export * from "./composeVoice.vue?vue&type=script&lang=js"

import "./composeVoice.vue?vue&type=style&index=0&id=5c54322b&scoped=true&lang=css"
import "./composeVoice.vue?vue&type=style&index=1&id=5c54322b&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c54322b"]])

export default __exports__